import _ from 'lodash'

export const getErrorMessage = (error) => {
  if (error.response) {
    if (error.response.request.responseType === 'arraybuffer') {
      try {
        return JSON.parse(new TextDecoder('utf-8').decode(error.response.data))
          .message
      } catch {
        // ignore
      }

      return error.message
    } else {
      if (_.isString(error.response.data)) {
        return error.response.data
      } else if (_.isObject(error.response.data)) {
        return error.response.data.message || error.message
      } else {
        return error.message
      }
    }
  } else if (error.code === 'ECONNABORTED') {
    // timeout
    return 'timeout'
  } else {
    console.log('Error', error.message)
    return error.message
  }
}
